import(/* webpackMode: "eager" */ "/vercel/path0/components/stock/components/company/CompanyInfo.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/stock/components/earnings/Earnings.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/stock/components/financials/Statement.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/stock/components/financials/Statement2.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/stock/components/financials/EarningsReport.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["ChartSection"] */ "/vercel/path0/components/stock/components/fundamentals/ChartSection.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/stock/components/fundamentals/Fundamentals.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["ChartWrapper"] */ "/vercel/path0/components/stock/components/lifestory/ChartWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/stock/components/news/NewsSummary.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/stock/components/announcements/Table.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/stock/components/announcements/StockAnnouncements.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/stock/components/peers/Peers.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["DoughnutChart"] */ "/vercel/path0/components/stock/components/revenues/DoughnutChart.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/stock/components/revenues/Revenues.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/stock/components/revenues/DataTable.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/stock/components/revenues/Tabs.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["BarChart"] */ "/vercel/path0/components/stock/components/sector-comparison/BarChart.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/stock/components/sector-comparison/Chart.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/stock/components/sector-comparison/ComparativeMetrics.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/stock/components/sector-comparison/SectorComparison.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/stock/[slug]/styles/page.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["BarChart"] */ "/vercel/path0/components/stock/components/share-holdings/charts/BarChart.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LineChart"] */ "/vercel/path0/components/stock/components/share-holdings/charts/LineChart.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PieChart"] */ "/vercel/path0/components/stock/components/share-holdings/charts/PieChart.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StockNavigation"] */ "/vercel/path0/components/stock/components/StockNavigation.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/stock/components/styles/ProsConsAnalysis.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/stock/components/styles/KeyInsights.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/stock/components/share-holdings/ShareholdingCharts.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/stock/components/styles/SummaryRanks.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
